import type { SVGProps, FC } from "react"

const SvgLogout: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16.001"
    {...props}
  >
    <g data-name="Group 152">
      <g data-name="Group 151" fill="#333">
        <path
          data-name="Path 121"
          d="M15.954 7.079a.674.674 0 0 0-.145-.217l-2-2a.667.667 0 0 0-.943.943l.862.862h-3.724a.667.667 0 0 0 0 1.333h3.724l-.862.862a.667.667 0 1 0 .943.943l2-2a.66.66 0 0 0 .145-.217.667.667 0 0 0 0-.509Z"
        />
        <path
          data-name="Path 122"
          d="M11.334 9.334a.667.667 0 0 0-.667.667v3.334H8.001V2.667a.667.667 0 0 0-.475-.639L5.21 1.333h5.458v3.334a.667.667 0 0 0 1.333 0v-4A.667.667 0 0 0 11.334 0H.667a.594.594 0 0 0-.069.013.658.658 0 0 0-.283.1C.301.121.286.121.269.132S.261.143.256.147a.661.661 0 0 0-.177.211.545.545 0 0 0-.019.056.632.632 0 0 0-.053.156.415.415 0 0 0 0 .058C.009.641 0 .653 0 .667V14a.666.666 0 0 0 .536.653l6.667 1.333a.62.62 0 0 0 .131.014.667.667 0 0 0 .667-.667v-.667h3.334a.667.667 0 0 0 .666-.666v-4a.667.667 0 0 0-.667-.666Z"
        />
      </g>
    </g>
  </svg>
)

export default SvgLogout
